/**
 * Injects JSON-LD structured data. Accepts one schema object or an array.
 * Escaping `<` prevents a stray "</script>" in free-text fields from breaking
 * out of the script tag (same hardening root.jsx applies to window.ENV).
 */
function safeJsonLd(data: Record<string, unknown>): string {
  return JSON.stringify(data).replace(/</g, "\\u003c");
}

export function SchemaMarkup({
  data,
}: {
  data: Record<string, unknown> | Record<string, unknown>[];
}) {
  const blocks = Array.isArray(data) ? data : [data];
  return (
    <>
      {blocks.map((block, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: safeJsonLd(block) }}
        />
      ))}
    </>
  );
}
